import React from 'react'

import OptionText from "./option-text"
import PopoverMenuSeparator from "../../../../../gd-components/popover-menu/popover-menu/popover-menu-separator"
import PopoverMenuHeader from "../../../../../gd-components/popover-menu/popover-menu/popover-menu-header"
import {PopoverMenuItemType} from "../../../../../gd-components/popover-menu/popover-menu/const";

// extends React.Component is required because of reference in parent

export type PopoverMenuOptionProps = {

    option          : Option

    isHighlighted?  : boolean
    isSelected?     : boolean

    onClick         : callback
}

export default class FieldAddress_PopoverOption extends React.Component<PopoverMenuOptionProps> {

    onClick = (e: React.MouseEvent) => {
        this.props.onClick(this.props.option, e)
    }

    render() {

        if (this.props.option.type === PopoverMenuItemType.SEPARATOR) {
            return <PopoverMenuSeparator />
        }

        if (this.props.option.type === PopoverMenuItemType.HEADER) {
            return <PopoverMenuHeader title={this.props.option.title} />
        }

        const RenderComponent = OptionText;
        return <RenderComponent option={this.props.option} isHighlighted={this.props.isHighlighted} isSelected={this.props.isSelected} onClick={this.onClick} />
    }
}
